import OriginalList from './FilePreview.svelte';
import OriginalItem from './Item.svelte';
import OriginalLeading from './Leading.svelte';
import Avatar from './Avatar.svelte';
import Description from './Description.svelte';
import OriginalExtra from './Extra.svelte';
import Icon from '../icon/Icon.svelte';
import Title from './Title.svelte';
import Action from './Action.svelte';
import OriginalFileContent from './FileContent.svelte';
import Status from './Status.svelte';
import OriginalUploadContent from './UploadContent.svelte';
import Uploading from './Uploading.svelte';
import Pending from './Pending.svelte';
import Complete from './Complete.svelte';
import Failed from './Failed.svelte';
import Rejected from './Rejected.svelte';
const List = OriginalList;
List.Item = OriginalItem;
List.Item.Leading = OriginalLeading;
List.Item.Leading.Avatar = Avatar;
List.Item.Leading.Icon = Icon;
List.Item.FileContent = OriginalFileContent;
List.Item.FileContent.Title = Title;
List.Item.FileContent.Description = Description;
List.Item.UploadContent = OriginalUploadContent;
List.Item.UploadContent.Status = Status;
List.Item.UploadContent.Action = Action;
List.Item.Extra = OriginalExtra;
List.Item.Extra.Uploading = Uploading;
List.Item.Extra.Pending = Pending;
List.Item.Extra.Complete = Complete;
List.Item.Extra.Failed = Failed;
List.Item.Extra.Rejected = Rejected;
export default List;
